import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../redux/actions/authActions';
import style from "./LoginComponent.module.css"

const LoginComponent = () => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState({ type: '', message: '' });  

  const handleLogin = async () => {
    if (!username) {
      setError({ type: 'username', message: 'Por favor ingrese el usuario.' });
      return;
    }

    if (!password) {
      setError({ type: 'password', message: 'Por favor ingrese el password.' });
      return;
    }

    setError({ type: '', message: '' });

    const credentials = { username, password };

    try {
      await dispatch(loginUser(credentials));
      
    } catch (err) {
      setError({ type: 'credentials', message: 'Credenciales incorrectas. Intenta nuevamente.' });
      setTimeout(() => {
        setError({ type: '', message: '' });
      }, 3000);
    }
  };

  return (
    <div className={style.loginComponent}>
      <h1>Api Portal</h1>

      <form className={style.Loginform} onSubmit={(e) => {
        e.preventDefault();
        handleLogin();
      }}>
        {error.type === 'credentials' && <div className={style.errorMessage}>{error.message}</div>}

        <div>
          <input
            className={style.Logininput}
            type="text"
            placeholder="Usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          {error.type === 'username' && <div className={style.errorMessage}>{error.message}</div>}
        </div>
        <div>
          <input
            className={style.Logininput}
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {error.type === 'password' && <div className={style.errorMessage}>{error.message}</div>}
        </div>
        <div>
          <button className={style.Loginbutton} type="submit">Iniciar sesión</button>
        </div>
      </form>

    </div>
  );
};

export default LoginComponent;
